<template functional>
    <div class="order-aside">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'OrderAside'
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/bootstrap/breakpoints' as breakpoints;

.order-aside {
    background-color: var(--body-bg);
}

.order-aside ::v-deep {
    .aside-teaser {
        height: 170px !important;

        .teaser-text {
            padding: 10px variables.$grid-padding;
            padding-top: 20px;

            .hotel-name {
                text-transform: uppercase;
                font-size: 14px;
            }

            .classification {
                font-size: 12px;
            }
        }
    }

    .details-section {
        padding-left: variables.$grid-padding;
        padding-right: variables.$grid-padding;
    }

    .heading {
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;

        &.skeleton {
            min-height: 48px;
        }
    }

    .order-details.skeleton {
        min-height: 210px;
    }

    .inline-justified {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;

        > span:first-child {
            text-transform: uppercase;
            font-size: 12px;
            font-weight: bold;
        }

        > span:last-child {
            text-align: right;
        }
    }

    .accommodation.skeleton {
        min-height: 80px;
    }

    .discount-aside-section {
        input.code {
            line-height: 1em;
        }

        .section-header {
            position: relative;
            padding-right: 110px;
        }

        .discount-toggle {
            display: flex;
            align-items: center;
            padding: 0;
            text-transform: uppercase;
            font-size: 12px;
            font-weight: bold;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            text-decoration: none;

            .icon-arrow-down {
                font-size: 18px;

                &.active {
                    transform: rotate(180deg);
                }
            }
        }
    }

    .purchase-button {
        text-transform: uppercase;
    }

    @include breakpoints.media-breakpoint-up(variables.$desktop-breakpoint-min) {
        .details-section {
            background-color: var(--white);

            &.darker {
                background-color: var(--aside-darker-bg);
            }

            .section-header {
                text-transform: uppercase;
                font-size: 12px;
                font-weight: 700;
                margin-bottom: 10px;
            }

            .indented {
                margin-left: 7px;

                &.accommodation {
                    line-height: 20px;
                }
            }
        }
    }

    @include breakpoints.media-breakpoint-down(variables.$mobile-breakpoint-max) {
        margin-left: -(variables.$grid-padding);
        margin-right: -(variables.$grid-padding);

        .details-section {
            .section-header {
                margin-bottom: 10px;
            }

            &.darker-mobile {
                background-color: var(--aside-darker-bg);
            }
        }

        .discount-aside-section {
            .discount-header {
                font-size: 14px;
                max-width: 100%;
                display: inline-block;
                line-height: 14px;
                vertical-align: baseline;
            }
        }

        .heading {
            font-weight: bold;
            text-transform: uppercase;
        }

        button[type='submit'] {
            max-width: 300px;
            margin-left: auto;
            margin-right: auto;
        }
    }
}
</style>
